import { ChangeEvent, useState } from 'react';
import Tags from "../../../types/Tags";
import ConditionalRender from "../../../helpers/ConditionalRender";
import Helper from "../../../helpers/Helper";
import './style.scss';

const Tagging = (props: { tags: Tags[], allTags: Tags[], setTags: Function, instanceId: number | undefined }) => {
    const { tags, setTags, allTags } = props;
    const [tagsWithoutDuplicates, setTagsWithoutDuplicates] = useState<Tags[]>([]);
    const [suggestions, setSuggestions] = useState<Tags[]>([]);
    const [suggestionsVisible, setSuggestionsVisible] = useState<boolean>(false);


    const [valuesSuggestions, setValuesSuggestions] = useState<string[]>([]);
    const [valuesSuggestionsVisible, setValuesSuggestionsVisible] = useState<boolean>(false);


    const [focusedInputIndex, setFocusedInputIndex] = useState<number>(-1);

    const handleChange = (index: number, event: ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        // Restricting characters `,` and `;` from being entered
        const sanitizedValue = value.replace(/[^A-Za-z0-9\s-]/g, ''); // Allow only numbers, letters, spaces, and hyphens

        const updatedFields: any[] = [...tags];
        updatedFields[index][name] = sanitizedValue;
        setTags(updatedFields);

        // Filter Suggestions List
        if (name === 'tagname') {
            const matchingOptions = tagsWithoutDuplicates.filter(option =>
                option.tagname.toLowerCase().includes(sanitizedValue.toLowerCase())
            );
            // Remove from lists tags that are already added
            const filteredList = Helper.filterArraysByKey(matchingOptions, tags, name);
            setSuggestions(filteredList);
        } else {
            const getTag = tagsWithoutDuplicates.find(tag => tag.tagname === tags[index].tagname)
            if (getTag?.tagvalues?.length) {
                const matchingOptions = getTag.tagvalues.filter((option: any) =>
                    option.toLowerCase().includes(sanitizedValue.toLowerCase())
                )
                setValuesSuggestions(matchingOptions)
            }
        }
    };

    const getTagSuggestionsList = (index: number, value: string) => {
        const list: any = Helper.filterTagsByTagName(allTags)
        // Remove from lists tags that are already added
        const filteredList = Helper.filterArraysByKey(list, tags, 'tagname');
        const matchingOptions = filteredList.filter(option =>
            option.tagname.toLowerCase().includes(value.toLowerCase())
        );
        setSuggestions(matchingOptions)
        if (matchingOptions.length) {
            setSuggestionsVisible(true)
            setFocusedInputIndex(index);
        } else {
            setSuggestionsVisible(false)
            setFocusedInputIndex(-1);
        }
        setTagsWithoutDuplicates(list)
    }

    const getTagValuesSuggestionsList = (index: number, value: Tags) => {
        const list: any = Helper.filterTagsByTagName(allTags)
        const tagExist = list.find((tag: Tags) => tag.tagname === value.tagname)
        if (tagExist && tagExist.tagvalues) {
            const matchingOptions = tagExist.tagvalues.filter((option: any) =>
                option.toLowerCase().includes(value.tagvalue.toLowerCase())
            )
            setValuesSuggestions(matchingOptions)
            setValuesSuggestionsVisible(true)
            setFocusedInputIndex(index);
        } else {
            setValuesSuggestionsVisible(false)
            setFocusedInputIndex(-1);
        }
    }

    const handleAddField = () => {
        setTags([...tags, {
            tagname: '',
            tagvalue: '',
            validName: true,
            validValue: true,
            datasourceid: props.instanceId
        }]);
    };

    const handleRemoveField = (index: number) => {
        const updatedFields = [...tags];
        updatedFields.splice(index, 1);
        setTags(updatedFields);
    };

    const handleFieldBlur = (pos: number, type: string, value?: string) => {
        const updatedTags = [...tags];

        if (type === 'tagname') {
            const nameExists = tags.filter(tag => tag.tagname === value);
            updatedTags[pos].validName = !!tags[pos].tagname.trim() && nameExists.length < 2;
            setTags(updatedTags);
        }

        if (type === 'tagvalue') {
            updatedTags[pos].validValue = !!tags[pos].tagvalue.trim();
            setTags(updatedTags);
        }

        // Delay for hiding suggestions (200ms)
        setTimeout(() => {
            if (type === 'tagname') setSuggestionsVisible(false);
            if (type === 'tagvalue') setValuesSuggestionsVisible(false);
        }, 200);

    };

    const selectSuggestedValue = (pos: number, value: any, isName: boolean) => {
        const updatedFields = [...tags];
        if (isName) {
            updatedFields[pos] = {
                tagname: value.tagname,
                tagvalue: '',
                datasourceid: props.instanceId
            }
            setSuggestionsVisible(false)
        } else {
            updatedFields[pos] = {
                tagname: updatedFields[pos].tagname,
                tagvalue: value,
                datasourceid: props.instanceId
            }
            setValuesSuggestionsVisible(false)
        }
        setTags(updatedFields);
    }

    return (
        <>
            <div className="col-xs-12 col-md-3">
                <span>
                    <label htmlFor="tags" className="reminder">
                        Tags
                    </label>
                </span>
                <span className="badge bg-info" data-tooltip-id="global-tooltip" data-tooltip-content="Total tags">
                    {tags.length.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                </span>
            </div>
            <div className="col-xs-12 col-md-6 col-lg-3 ">
                {tags.map((field: Tags, index: number) => (
                    <div key={index} className='d-flex g-0 mb-1 justify-content-between'>
                        <div>
                            <input
                                type="text"
                                name="tagname"
                                autoComplete="off"

                                className={`form-control ${field.validName === false ? 'is-invalid' : ''}`}
                                placeholder="Tag Name"
                                onFocus={() => getTagSuggestionsList(index, field.tagname)}
                                onBlur={() => handleFieldBlur(index, 'tagname', field.tagname)}
                                value={field.tagname}
                                onChange={(event) => handleChange(index, event)}
                            />
                            <ConditionalRender
                                if={suggestionsVisible && focusedInputIndex === index && suggestions.length}>
                                <div className='suggestions-list dropdown-menu show'>
                                    {suggestions.map((item: Tags, i: number) => (
                                        <ul key={i}>
                                            <li>
                                                <button type="button" className='dropdown-item'
                                                   onMouseDown={(e) => e.preventDefault()}
                                                   onClick={() => selectSuggestedValue(index, item, true)}>
                                                    {item.tagname}
                                                </button>
                                            </li>
                                        </ul>
                                    ))}
                                </div>
                            </ConditionalRender>
                        </div>
                        <div>
                            <input
                                type="text"
                                autoComplete="off"
                                name="tagvalue"
                                className={`form-control mx-1 ${field.validValue === false ? 'is-invalid' : ''}`}
                                placeholder="Value"
                                disabled={!field.tagname}
                                onFocus={() => getTagValuesSuggestionsList(index, field)}
                                onBlur={() => handleFieldBlur(index, 'tagvalue', field.tagvalue)}
                                value={field.tagvalue}
                                onChange={(event) => handleChange(index, event)}
                            />
                            <ConditionalRender
                                if={valuesSuggestionsVisible && focusedInputIndex === index && valuesSuggestions.length}>
                                <div className='suggestions-list dropdown-menu show'>
                                    {valuesSuggestions.map((item: string, i: number) => (
                                        <ul key={i}>
                                            <li>
                                                <button type="button" className='dropdown-item'
                                                   onMouseDown={(e) => e.preventDefault()}
                                                   onClick={() => selectSuggestedValue(index, item, false)}>
                                                    {item}
                                                </button>
                                            </li>
                                        </ul>
                                    ))}
                                </div>
                            </ConditionalRender>
                        </div>
                        <button type="button" className="btn btn-small btn-dark"
                                onClick={() => handleRemoveField(index)}>
                            <i className="fal fa-times"/>
                        </button>
                    </div>
                ))}
                <ConditionalRender if={tags.length < 20}>
                    <button className="btn btn-success" onClick={handleAddField}>
                        <i className='fal fa-square-plus'/>
                        <span>Add more</span>
                    </button>
                </ConditionalRender>
            </div>
            <div className="w-100"/>
        </>
    );
};

export default Tagging;
